import { render } from "./ExamRegistrationForm.vue?vue&type=template&id=0e513f64&scoped=true"
import script from "./ExamRegistrationForm.vue?vue&type=script&lang=js"
export * from "./ExamRegistrationForm.vue?vue&type=script&lang=js"

import "./ExamRegistrationForm.vue?vue&type=style&index=0&id=0e513f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e513f64"]])

export default __exports__